/**
 * Validación de longitud del número telefónico al INTRODUCIRLO (antes de guardar
 * o de enviar un WhatsApp). Complementa a `isSendablePhone` (que solo exige un
 * mínimo genérico de dígitos) detectando números nacionales con una longitud
 * imposible para su prefijo de país.
 *
 * Incidente que lo motiva (2026-06-17): un móvil español se tecleó como
 * "60213493" (8 dígitos) en vez de "602213493" (9). El número resultante
 * "+3460213493" pasaba `isSendablePhone` (>=8 dígitos totales) y se enviaba a
 * Meta, que lo rechazaba con error 131026 "Message undeliverable" (la "!").
 *
 * Para los prefijos con longitud nacional fija conocida (de momento España)
 * exigimos esa longitud exacta. Para el resto aplicamos un rango razonable.
 */

// Longitud EXACTA del número nacional (sin prefijo de país) para los prefijos
// con un plan de numeración fijo conocido. España: 9 dígitos.
const EXACT_NATIONAL_LENGTH = {
  "+34": 9, // España
};

// Rango genérico para prefijos sin longitud fija conocida.
const GENERIC_MIN = 6;
const GENERIC_MAX = 14;

/**
 * @param {string} prefix prefijo de país con "+" (p. ej. "+34")
 * @param {string} nationalNumber número nacional tal cual lo teclea el usuario
 * @returns {{ valid: boolean, message: string|null }}
 */
export function validateNationalPhone(prefix, nationalNumber) {
  // Normalizamos igual que la ruta de envío: solo dígitos y sin ceros iniciales.
  const digits = String(nationalNumber || "")
    .replace(/\D+/g, "")
    .replace(/^0+/, "");

  if (!digits) {
    return { valid: false, message: "Introduce un número de teléfono." };
  }

  const exact = EXACT_NATIONAL_LENGTH[String(prefix || "").trim()];
  if (exact) {
    if (digits.length !== exact) {
      return {
        valid: false,
        message: `El número para ${prefix} debe tener ${exact} dígitos (tiene ${digits.length}).`,
      };
    }
    return { valid: true, message: null };
  }

  if (digits.length < GENERIC_MIN || digits.length > GENERIC_MAX) {
    return {
      valid: false,
      message: `El número no parece válido (${digits.length} dígitos).`,
    };
  }

  return { valid: true, message: null };
}
